import { useMemo }           from 'react';
import { GridValidRowModel } from '@mui/x-data-grid-pro';

import { Modal }            from '@shared/components/modals/Modal';
import { GridColTextInput } from '@shared/components/grid/GridColTextInput';
import { newGridRecordId }  from '@shared/commonFunctions';
import { dataGridCol }      from '@shared/components/grid/common';
import { PhoenixGrid }      from '@shared/components/grid/PhoenixGrid';

import {
  requestCreateSidConfig,
  requestDeleteSidConfig,
  requestUpdateSidConfig
}                                             from '../requests';
import { useConfigureSidsValidationSchema } from '../validation';
import { ISid }                             from '../types';

const columns = [
  dataGridCol('source', {
    headerName     : 'Label',
    minWidth       : 150,
    flex           : 1,
    editable       : true,
    renderEditCell : (params) => <GridColTextInput params={params} />,
  }),
  dataGridCol('sid', {
    headerName     : 'Configured SID',
    minWidth       : 200,
    flex           : 1,
    editable       : true, 
    renderEditCell : (params) => <GridColTextInput params={params} />,
  }),
];

interface IConfigureSidsModalProps {
  sids? : ISid[];
  error   : boolean;
  configureSidModalPosition: number;
  mutate  : () => void;
  onClose : () => void;
}

export const ConfigureSidsModal = ({ onClose, sids, error, configureSidModalPosition, mutate }: IConfigureSidsModalProps) => {
  const configureSidsValidationSchema = useConfigureSidsValidationSchema();

  const actions = useMemo(() => ({
    onSave: async({ id, source, sid }: GridValidRowModel) => {
      let response = null;
      if (id === newGridRecordId) {
        response =  await requestCreateSidConfig(source, sid);
      } else {
        response = await requestUpdateSidConfig(id, source, sid);
      }

      if (!response?.error) {
        mutate();
      }
      return response;
    },
    onDelete: async({ id }: GridValidRowModel) => {
      await requestDeleteSidConfig(id);
      mutate();
    },
  }), [requestDeleteSidConfig, requestCreateSidConfig, requestUpdateSidConfig, mutate]);

  return (
    <Modal 
      open
      hideBackdrop
      resetPosition={configureSidModalPosition}
      title="Configure SIDs"
      dialogWidth="700px" 
      onClose={onClose}
    >
      <PhoenixGrid
        withHeader
        canNotCopy
        strict
        height         = "500px"
        loading        = {!sids && !error}
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        actions        = {actions}
        columns        = {columns}
        validateSchema = {configureSidsValidationSchema}
        rows           = {sids || []}
      />
    </Modal>
  );
};
